import styled, { css } from 'styled-components';
export const ChartContainer = styled.div `
  width: 100%;
  height: 100%;
  position: relative;
`;
export const LoadingContainer = styled.div `
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: "Suisse Int'l", sans-serif;
  color: var(--text-secondary-invert);
`;
export const ChartDiv = styled.div `
  width: 100%;
  height: 100%;
`;
export const TooltipStyles = css `
  display: inline-flex;
  max-width: 200px;
  padding: var(--space-100) var(--space-200);
  flex-direction: column;
  align-items: flex-start;
  gap: var(--space-200);
  border-radius: var(--radius-brand);
  background: var(--bg-primary-invert);
  z-index: 5;
`;
export const TooltipItemContainerStyles = css `
  display: flex;
  align-items: center;
  gap: var(--space-200);
`;
export const TooltipItemContentStyles = css `
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
`;
export const TooltipItemLabelStyles = css `
  color: var(--text-secondary-invert);
  font-size: var(--font-size-300);
  font-weight: var(--font-weight-medium);
  line-height: var(--font-line-height-300);
  letter-spacing: var(--font-letter-spacing-loose);
`;
export const TooltipItemValueStyles = css `
  color: var(--text-primary-invert);
  font-size: var(--font-size-300);
  font-weight: var(--font-weight-medium);
  line-height: var(--font-line-height-300);
  letter-spacing: var(--font-letter-spacing-loose);
`;
export const TooltipItemPointStyles = css `
  width: 12px;
  height: 12px;
  border-radius: 100px;
`;
